interface VisibilityOverlayProps {
  onPreviewAnyway: () => void
  onHideScreen: () => void
}

export const VisibilityOverlay = ({ onPreviewAnyway, onHideScreen }: VisibilityOverlayProps) => {
  return (
    <div className='absolute inset-0 z-50'>
      {/* Background blur layer with CSS filter */}
      <div
        className='absolute inset-0 bg-white/10'
        style={{
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      />

      {/* Overlay with dark background */}
      <div className='absolute inset-0 bg-black/40 flex items-center justify-center'>
        <div className='text-white text-center px-4'>
          <p className='text-md font-bold drop-shadow-lg mb-4'>This screen&apos;s visibility condition is false.</p>
          <div className='flex flex-col gap-2'>
            <button className='text-white underline text-sm cursor-pointer' onClick={onPreviewAnyway}>
              Preview anyway
            </button>
            <button className='text-white underline text-sm cursor-pointer' onClick={onHideScreen}>
              Hide screen
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
